import { useMemo } from 'react';

import uniq from 'lodash/uniq';
import { FilterSelect, useSearchContext } from '@cast/shared-search-ui';

import { AgentStatus, Cluster } from '@cast/types';
import { Box } from '@cast/design-system';

const AGENT_STATUS_LABELS: Record<AgentStatus, string> = {
  [AgentStatus.ONLINE]: 'Online',
  [AgentStatus.CONNECTING]: 'Connecting',
  [AgentStatus.NOT_RESPONDING]: 'Not responding',
  [AgentStatus.DISCONNECTING]: 'Disconnecting',
  [AgentStatus.DISCONNECTED]: 'Disconnected',
};

type AgentStatusFilterProps = {
  fullWidth?: boolean;
};

export const AgentStatusFilter = ({ fullWidth }: AgentStatusFilterProps) => {
  const searchCtx = useSearchContext<Cluster>();

  const options = useMemo(
    () =>
      uniq(
        (searchCtx?.data
          ?.map((cluster) => cluster.agentStatus)
          .filter((status) => !!status) as AgentStatus[]) || []
      ).map((value) => ({
        title: AGENT_STATUS_LABELS[value] ?? value,
        value,
      })),
    [searchCtx?.data]
  );

  return (
    <Box sx={fullWidth ? { width: '100%' } : undefined}>
      <FilterSelect
        criterion="agentStatus"
        options={options}
        SelectProps={{ inputText: 'Agent status', size: 'md' }}
        multiple
        sx={{ width: '100%' }}
        testId="clusters-agent-status-filter"
      />
    </Box>
  );
};
